import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

export const ConfirmDialog = ({ open, title, body, onConfirm, onCancel, confirmLabel = "Delete" }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent className="max-w-[92vw] sm:max-w-md" data-testid="confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{body}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="min-h-[48px]" data-testid="confirm-cancel-btn">Cancel</AlertDialogCancel>
        <AlertDialogAction className="min-h-[48px] bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm} data-testid="confirm-ok-btn">
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
